/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTContextMenu } from './context-menu';
export type {
	KTContextMenuConfigInterface,
	KTContextMenuInterface,
} from './types';
